import { render, staticRenderFns } from "./Vagas_Ultimas.vue?vue&type=template&id=5f6c61d2&scoped=true"
import script from "./Vagas_Ultimas.vue?vue&type=script&lang=js"
export * from "./Vagas_Ultimas.vue?vue&type=script&lang=js"
import style0 from "./Vagas_Ultimas.vue?vue&type=style&index=0&id=5f6c61d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6c61d2",
  null
  
)

export default component.exports